var exports = {
  "kL": "FormSwitch.module__container___aW1Wdl",
  "oE": "FormSwitch.module__compact___aW1Wdl",
  "_A": "FormSwitch.module__labelContainer___aW1Wdl",
  "Pf": "FormSwitch.module__label___aW1Wdl",
  "r9": "FormSwitch.module__disabled___aW1Wdl",
  "vk": "FormSwitch.module__clickable___aW1Wdl",
  "h_": "FormSwitch.module__description___aW1Wdl",
  "HV": "FormSwitch.module__switchRoot___aW1Wdl",
  "L8": "FormSwitch.module__switchThumb___aW1Wdl",
  "nL": "FormSwitch.module__iconChecked___aW1Wdl",
  "ao": "FormSwitch.module__iconUnchecked___aW1Wdl",
};

module.exports = exports;
